export default {
      id: "ic-drag-drop-usage",
      viewBox: "0 0 12 13",
      url: "/" + "images/icons.3.109.2.svg#ic-drag-drop-usage",
      toString: function () {
        return this.url;
      }
    }